export interface NestedItem {
  value: string;
  label: string;
  inputType?: InputType;
  subNestedItem?: NestedItem[];
}

export interface MenuItem {
  label: string;
  value: string;
  inputType?: InputType;
  children: MenuItem[];
}

export type InputType = 'checkbox' | 'radio' | 'title';

type CategoryListUtilityReturn = MenuItem[];

export function createMenuItems(
  categories: NestedItem[]
): CategoryListUtilityReturn {
  return categories.map((category) => {
    const hasChildren =
      category.subNestedItem && category.subNestedItem.length > 0;
    return {
      label: category.label,
      value: category.value,
      inputType: category.inputType,
      children: hasChildren
        ? createMenuItems(category.subNestedItem || [])
        : [],
    };
  });
}
